import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { LogService } from '../../shared/log/log.service';
import { ReservationCompareStore } from '../service/reservation-compare-store';

@Injectable()
export class ReservationDetailResolver implements Resolve<any> {

  constructor(
    private reservationCompareStore: ReservationCompareStore,
    private flashMessagesService: FlashMessagesService,
    private router: Router,
    private logService: LogService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let obs$: Observable<boolean>;

    const id = route.params['id'];
    this.reservationCompareStore.getReservations(id).subscribe(() => {
      obs$ = this.reservationCompareStore.isRsvpCompareListEmpty();

      obs$.take(1).subscribe(isEmpty => {
        if (!isEmpty) {
          this.reservationCompareStore.selectedRsvpId = Number(route.queryParams['rsvp']);
          this.reservationCompareStore.selectedReservationId = Number(route.queryParams['reservation']);

          const path = route.url.map(urlSegment => urlSegment.path).join('/');
          this.logService.info('router URL path ends with /detail: ' + path.endsWith('/detail'));
          this.reservationCompareStore.setShowReservationCompareSummary(!path.endsWith('/detail'));
        } else {
          this.router.navigate(['event/' + id + '/reservations']).then(() => {
            this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE');
          });
        }
      });
    });

    return obs$;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/reservation-detail.resolver.ts